import { EditIcon, Header, IconButton, Paragraph } from "@datagame/ui";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import classNames from "classnames/bind";

import { useUser } from "../../../hooks/user";
import { PasswordForm } from "./PasswordForm";
import { DeleteAccountForm } from "./DeleteAccountForm";
import { UserForm } from "./UserForm";
import { User } from "../../../gql/graphql";

import styles from "./ProfileView.module.scss";

export type UserInterface = Omit<User, "organization" | "organizationId"> & {
  organization?: {
    name: string;
  };
};

const cx = classNames.bind(styles);

export const ProfileView = () => {
  const { user, loading } = useUser();
  const [isEditingProfile, setIsEditingProfile] = useState(false);
  const [isEditingPassword, setIsEditingPassword] = useState(false);

  const { t } = useTranslation();

  if (loading || !user) {
    return null;
  }

  return (
    <div className={styles.container}>
      <div className={styles.sectionContainer}>
        <div className={cx("section", "profile")}>
          <div className={styles.headerSection}>
            <div className={styles.headerWrapper}>
              <Header variant="h5">{t("profile:profileSection.title")}</Header>
              <Paragraph size="small" color="secondary">
                {t("profile:profileSection.description")}
              </Paragraph>
            </div>
            <IconButton
              disabled={isEditingProfile}
              style="primary"
              icon={<EditIcon />}
              size="large"
              onClick={() => setIsEditingProfile(!isEditingProfile)}
            />
          </div>

          <UserForm user={user} isActive={isEditingProfile} onSubmit={() => setIsEditingProfile(false)} />
        </div>

        <div className={cx("section", "password")}>
          <div className={styles.headerSection}>
            <div className={styles.headerWrapper}>
              <Header variant="h5">{t("profile:passwordSection.title")}</Header>
              <Paragraph size="small" color="secondary">
                {t("profile:passwordSection.description")}
              </Paragraph>
            </div>
            <IconButton
              disabled={isEditingPassword}
              style="primary"
              icon={<EditIcon />}
              size="large"
              onClick={() => setIsEditingPassword(!isEditingPassword)}
            />
          </div>
          <PasswordForm onSubmit={() => setIsEditingPassword(false)} isActive={isEditingPassword} />
        </div>
      </div>

      <div className={cx("section", "deleteAccount")}>
        <div className={styles.headerSection}>
          <div className={styles.headerWrapper}>
            <Header variant="h5">{t("profile:deleteAccountSection.title")}</Header>
            <Paragraph size="small" color="secondary">
              {t("profile:deleteAccountSection.description")}
            </Paragraph>
          </div>
        </div>

        <DeleteAccountForm />
      </div>
    </div>
  );
};
